/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { PlanActions, PlanActionTypes, PlanState } from './types';

export const initialPlanState: PlanState = {
  isFetching: false,
  planCompute: undefined,
  planStorage: undefined,
  errorMessage: undefined,
};

export function plan(state = initialPlanState, action: PlanActionTypes): PlanState {
  switch (action.type) {
    case PlanActions.GET_PLAN_REQUEST:
      return {
        ...state,
        isFetching: true,
        errorMessage: undefined,
      };
    case PlanActions.GET_PLAN_SUCCESS:
      return {
        ...state,
        isFetching: false,
        planCompute: action.payload.compute,
        planStorage: action.payload.storage,
      };
    case PlanActions.GET_PLAN_FAILURE:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.payload.errorMessage,
      };
    default:
      return state;
  }
}
